import React from 'react';
import moment from 'moment-timezone';
import { CommunicationsAnnouncementResult } from '../../../model/CommunicationsAnnouncementsResult';
import { getExternalLink } from '../../stock/AnnouncementTable';
import { size } from './EditAnnouncement';
import { pluralize } from '../../../util/util';

interface Props {
    detail: CommunicationsAnnouncementResult;
}

const TZ = 'Australia/Sydney';

// spec 2:57821. Omitted: Category (tags cover it), ASX reference, Added by, Where It Appears, likes and the signed-in splits.
const AnnouncementDetails: React.FC<Props> = ({ detail }) => {
    const { row } = detail;
    const released = moment(row.date).tz(TZ);
    const lag = moment(detail.fetched).diff(moment(row.date), 'minutes');
    const pdfName = (row.localPath || '').split('/').pop() || 'announcement.pdf';
    const lastSend = detail.sends[detail.sends.length - 1];

    const field = (label: string, value: React.ReactNode, strong = false) =>
        <div className="field"><dt>{label}</dt><dd className={strong ? 'strong' : ''}>{value}</dd></div>;

    const tile = (value: string, label: string, sub: string) =>
        <div className="tile"><div className="v">{value}</div><div className="l">{label}</div><div className="s">{sub}</div></div>;

    return <div className="main announcement-details">
        <div className="card">
            <h2>The Announcement</h2>
            {lag >= 0 && moment(detail.fetched).year() > 2000 &&
                <p className="sub">Pulled automatically from the ASX {lag < 1 ? 'within a minute' : moment.duration(lag, 'minutes').humanize()} after release</p>}
            <dl>
                {field('Headline', row.headline, true)}
                {field('Released to the ASX', `${released.format('D MMMM YYYY, h:mm a')} Sydney`)}
                {field('Type', row.priceSensitive ? 'Price sensitive' : 'Not price sensitive')}
                {field('Document', <a href={getExternalLink({ localPath: row.localPath })} target="_blank" rel="noopener noreferrer">
                    {[pdfName, row.pages > 0 && pluralize('page', row.pages), row.fileSize > 0 && size(row.fileSize)].filter(x => x).join(' · ')}</a>)}
                {field('Tags', row.tags.length ? row.tags.join(' · ') : 'None')}
            </dl>
        </div>

        <div className="card">
            <h2>How It Is Doing</h2>
            <div className="tiles">
                {tile(row.views.toLocaleString(), 'views', 'on your website')}
                {tile(row.questions.toLocaleString(), 'questions', 'from investors')}
                {lastSend
                    ? tile('Sent', 'emails', moment(lastSend.timestamp).tz(TZ).format('D MMM YYYY, h:mm a'))
                    : tile('—', 'emails', 'not sent yet')}
            </div>
        </div>
    </div>;
};

export default AnnouncementDetails;
